import axios from "axios"
import { COMPANIES_STATUS } from "../../../../../utility/SourceAPI"

export const fetchCompaniesStatus = async () => {
    const response = await axios.get(COMPANIES_STATUS)
    return response.data
}

export const createCompanyStatus = async (status) => {
    const response = await axios.post(COMPANIES_STATUS, status)
    return response.data
}
